export default [
    {
        path: "/message",
        name: "message",
        component: () => import("./index"),
        meta: {
            title: "推送消息"
        },
    },
    {
        path: "/message/alarm/:id",
        name: "messageAlarm",
        component: () => import("./components/AlarmMessageInfo"),
        meta: {
            title: "告警消息详情"
        },
    },
    {
        path: "/message/device/:id",
        name: "messageDevice",
        component: () => import("./components/DeviceMessageInfo"),
        meta: {
            title: "报装消息详情"
        },
    },
    {
        path: "/message/system/:id",
        name: "messageSystem",
        component: () => import("./components/SystemMessageInfo"),
        meta: {
            title: "系统消息详情"
        },
    },
]